import { createRouter, createRoute, createRootRoute } from '@tanstack/react-router';
import { RootLayout } from './RootLayout.js';
import { LoginPage } from '../modules/auth/LoginPage.js';
import { AppLayout } from './AppLayout.js';
import PulsePage from '../modules/pulse/PulsePage.js';
import { MediaBuyerPage } from '../modules/media-buyer/MediaBuyerPage.js';
import { QualityControlPage } from '../modules/quality-control/QualityControlPage.js';
import { GuardianPage } from '../modules/guardian/GuardianPage.js';
import IVRPage from '../modules/ivr/IVRPage.js';
import NetworkPage from '../modules/network/NetworkPage.js';
import StudioPage from '../modules/studio/StudioPage.js';
import { SettingsPage } from '../modules/settings/SettingsPage.js';

const rootRoute = createRootRoute({ component: RootLayout });

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
});

const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'app',
  component: AppLayout,
});

const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/',
  component: PulsePage,
});

const pulseRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/pulse',
  component: PulsePage,
});

const mediaBuyerRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/media-buyer',
  component: MediaBuyerPage,
});

const qualityControlRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/quality-control',
  component: QualityControlPage,
});

const guardianRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/guardian',
  component: GuardianPage,
});

const ivrRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/ivr',
  component: IVRPage,
});

const networkRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/network',
  component: NetworkPage,
});

const studioRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/studio',
  component: StudioPage,
});

const settingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/settings',
  component: SettingsPage,
});

const routeTree = rootRoute.addChildren([
  loginRoute,
  appRoute.addChildren([
    indexRoute,
    pulseRoute,
    mediaBuyerRoute,
    qualityControlRoute,
    guardianRoute,
    ivrRoute,
    networkRoute,
    studioRoute,
    settingsRoute,
  ]),
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
